const API_BASE = "/api/v1/automap";
const ADMIN_BASE = "/api/admin/automotive";

async function parseJson(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.message || `Request failed (${response.status})`);
  }
  return body;
}

export async function fetchListingVehicleRisk(listingId, context = "buyer") {
  const response = await fetch(`${API_BASE}/listings/${listingId}/risk?context=${context}`);
  const body = await parseJson(response);
  return body.snapshot || body;
}

export async function fetchAdminListingVehicleRisk(listingId) {
  const response = await fetch(`${ADMIN_BASE}/vehicle-risk/listings/${listingId}?context=admin`, {
    credentials: "include",
  });
  return parseJson(response);
}

export async function recalculateAdminListingVehicleRisk(listingId) {
  const response = await fetch(`${ADMIN_BASE}/vehicle-risk/listings/${listingId}/recalculate`, {
    method: "POST",
    credentials: "include",
  });
  return parseJson(response);
}

export async function fetchVehicleRiskRules() {
  const response = await fetch(`${ADMIN_BASE}/vehicle-risk/rules`, { credentials: "include" });
  return parseJson(response);
}

export async function fetchDealerVehicleRiskInsights(dealerId) {
  const response = await fetch(`${API_BASE}/dealer-portal/dealers/${dealerId}/risk-insights`, {
    credentials: "include",
  });
  return parseJson(response);
}
